import React, { useEffect, useState } from "react";
import { initiateKyc } from '../../actions/auth';

import actionIcon from "../../assets/img/icon/phoneIcon.png";

import './toDo.css';

const PhoneNumberVerify = ({ userDetails }) => {
  const [isDone, setIsDone] = useState();
  
    useEffect(() => {
        if (userDetails?.phone_verified_at) {
            setIsDone(true);
        }
    }, [userDetails]);

  return (
    <section className="toDoList-card rounded-2">
      <div className="toDo-container">
        <div className="toDo-icon">
          <img src={actionIcon} alt="KYC Verification" className="img-fluid" />
        </div>
        <div className="toDo-text">
          <h4>Phone Number</h4>
          <p>Kindly verify your phone number</p>
        </div>
        <button 
          className={`toDo-button ${isDone ? "done-button" : ""}`}
          disabled={isDone}
          data-bs-toggle={!isDone ? "modal" : ""}
          data-bs-target={!isDone ? "#verifyNumberModal" : ""}
        >
          Verify Now
          {/* {sdkLoaded ? "Verify Now" : "Loading..."} */}
        </button>
      </div>
    </section>
  );
};

export default PhoneNumberVerify;